<template>
  <div class="w-100">
    <b-skeleton width="100%" height="260px"> </b-skeleton>
    <b-row>
      <b-col cols="9">
        <b-skeleton width="100%" height="500px"> </b-skeleton>
      </b-col>
      <b-col cols="3">
        <b-skeleton width="100%" height="300px"> </b-skeleton>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BSkeleton, BSkeletonWrapper, BCol, BRow } from "bootstrap-vue";
export default {
  components: {
    BSkeleton,
    BSkeletonWrapper,
    BCol,
    BRow,
  },
};
</script>
